import React, { useEffect, useState } from "react";
import FocusEcole from "./FocusEcole";
import { ADMIN_SERVER_BASE_URL, apiClient } from "../util/apiClient";
import { useDispatch, useSelector } from "react-redux";
import { IMessage, setMessages } from "../store/messagerieSlice";
import { arrayData, dataSideBar } from "./constant";
import { anneescolaire } from "../util/constant";
import { IReduxState } from "../store";

function Messagerie() {

  const dispatch = useDispatch()
  const messages = useSelector((state: IReduxState) => state.messagerie).messages;

  const [selected, setSelected] = React.useState<readonly number[]>([]);
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [filteredMessages, setFilteredMessages] = useState<IMessage[]>([])


  const getMessages = async () => {
    try {
      // dispatch(setMessages(arrayData))
      const res: any = await apiClient.get(ADMIN_SERVER_BASE_URL, `/tablesystem/getallnotifications/${anneescolaire}`);
      if (res.status === 1) {
        dispatch(setMessages(res.data))
      } else {
        console.log("else getMessages")
      }
    } catch (error) {
      console.log("🚀 ~ getMessages ~ error:", error)
    }
  };

  useEffect(() => {
    getMessages()
  }, [])



  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected: any = dataSideBar[selectedIndex]?.status === undefined
        ? messages.map((n) => n.messageId)
        : messages.filter(elt => elt.messageArcived === dataSideBar[selectedIndex]?.status).map((n) => n.messageId);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event: React.MouseEvent<unknown>, id: number) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: readonly number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };


  return (
    <div
      style={{
        padding: 10,
        height: "80vh",
        overflow: "auto"
      }}
    >
      <FocusEcole
        selectedIndex={selectedIndex}
        setSelectedIndex={setSelectedIndex}
        filteredMessages={filteredMessages}
        setFilteredMessages={setFilteredMessages}
        handleSelectAllClick={handleSelectAllClick}
        handleClick={handleClick}
      />
    </div>
  );
}

export default Messagerie;
